import { JourneyType } from '@/types/enum'
import { goodsTypes, cargoTypes, placeTypes, embarkingTypes, vehicleAxlesTypes, Helper as _ } from '@/types'

const { STANDARD, ROUND, SHUTTLE, EMPTY } = JourneyType

export default {
  props: {
    journey: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      placeTypeItems: [
        { id: 'D', desc: 'Deposito', icon: 'mdi-home' },
        { id: 'I', desc: 'Interporto', icon: 'mdi-home-city' },
        { id: 'P', desc: 'Porto', icon: 'mdi-ferry' },
        { id: 'A', desc: 'Aeroporto', icon: 'mdi-airport' },
        { id: 'S', desc: 'Stazione ferroviaria', icon: 'mdi-train' },
        { id: 'X', desc: 'Altro', icon: 'mdi-map-marker-outline' },
      ],
    }
  },
  computed: {
    // Journey
    isEmpty() {
      return this.journey?.type === EMPTY
    },
    isStandard() {
      return this.journey?.type === STANDARD
    },
    isRound() {
      return this.journey?.type === ROUND
    },
    isShuttle() {
      return this.journey?.type === SHUTTLE
    },
    isForeign() {
      return this.originIsForeign || this.destinationIsForeign
    },
    // Places
    originType() {
      return this.journey?.origin_type
    },
    destinationType() {
      return this.journey?.destination_type
    },
    originDisplay() {
      // return this.journey?.origin?.full_name
    },
    destinationDisplay() {
      return this.journey?.destination?.full_name
    },
    originFullName() {
      return this.journey?.origin?.full_name
    },
    destinationFullName() {
      return this.journey?.destination?.full_name
    },
    originTypeDesc() {
      return _(placeTypes).getDescById(this.originType)
    },
    destinationTypeDesc() {
      return _(placeTypes).getDescById(this.destinationType)
    },
    originTypeIcon() {
      return this.placeTypeIcon(this.originType)
    },
    destinationTypeIcon() {
      return this.placeTypeIcon(this.destinationType)
    },
    originPlace() {
      return this.journey?.origin
    },
    destinationPlace() {
      return this.journey?.destination
    },
    originCountry() {
      return this.originPlace?.country
    },
    destinationCountry() {
      return this.destinationPlace?.country
    },
    originCountryId() {
      return this.originCountry?.id
    },
    destinationCountryId() {
      return this.destinationCountry?.id
    },
    originIsForeign() {
      return this.originCountryId !== 'IT'
    },
    destinationIsForeign() {
      return this.destinationCountryId !== 'IT'
    },
    hasCrossedBorder() {
      return !!this.journey?.crossed_border
    },
    crossedBorderDisplay() {
      return this.journey?.crossed_border?.name
    },
    hasCrossedCountries() {
      return this.journey?.crossed_countries.length > 0
    },
    crossedCountriesDisplay() {
      return this.journey?.crossed_countries?.map((c) => c.name)?.join(', ') ?? ''
    },
    hasDifferentPlaces() {
      return (
        this.journey?.origin && this.journey?.destination && this.journey?.origin?.id !== this.journey?.destination?.id
      )
    },
    totalDistance() {
      return this.journey?.distance_total
    },
    totalDistancePerJourney() {
      return this.journey?.distance_loaded + this.journey?.distance_empty
    },
    journeysCount() {
      return this.journey?.journeys_count
    },
    totalEmptyDistance() {
      return this.journey?.distance_empty * this.journeysCount
    },
    stopsCount() {
      return this.journey?.stops_count || 11
    },
    stopsProvinceCount() {
      return this.journey?.stops_province_count || 0
    },
    isEmbarked() {
      return this.journey?.embarking
    },
    embarkingType() {
      return this.journey?.embarking_type
    },
    embarkingTypeDesc() {
      return _(embarkingTypes).getDescById(this.embarkingType)
    },
    embarkingFromFullName() {
      return this.journey?.embarking_from?.full_name
    },
    embarkingToFullName() {
      return this.journey?.embarking_to?.full_name
    },
    embarkingFromDisplay() {
      return this.journey?.embarking_from?.full_name
    },
    embarkingToDisplay() {
      return this.journey?.embarking_to?.full_name
    },
    hasCoupledVehicle() {
      return !!this.journey?.coupled_vehicle
    },
    coupledVehicleAxles() {
      return this.journey?.coupled_vehicle_axles
    },
    coupledVehicleDesc() {
      switch (this.journey?.coupled_vehicle) {
        case 1:
          return 'Rimorchio'
        case 2:
          return 'Semirimorchio'
        default:
          return
      }
    },
    coupledVehicleAxlesDesc() {
      return this.journey?.coupled_vehicle_axles
    },
    coupledVehicleLoadCapacity() {
      return this.journey?.coupled_vehicle_load_capacity
    },
  },
  methods: {
    goodsTypeDesc(goods) {
      return _(goodsTypes).getDescById(goods?.type)
    },
    goodsCargoTypeDesc(goods) {
      return _(cargoTypes).getDescById(goods?.aspect)
    },
    placeTypeDesc(type) {
      return _(placeTypes).getDescById(type)
    },
    placeTypeIcon(type) {
      return this.placeTypeItems.find((i) => i.id === type)?.icon ?? 'mdi-map-marker-outline'
    },
  },
}
